import { Box, Avatar, Badge, Text, Flex, Image, Divider, Tooltip } from "@chakra-ui/react";
import DepartmentFrame from "../../../../assets/images/DepartmentFrame.svg";
import BranchFrame from "../../../../assets/images/BranchFrame.svg";
import EmailFrame from "../../../../assets/images/EmailFrame.svg";
import PhoneFrame from "../../../../assets/images/PhoneFrame.svg";
import GenderFrame from "../../../../assets/images/GenderFrame.svg";
import CalenderFrame from "../../../../assets/images/CalenderFrame.svg";
import PayrollFrame from "../../../../assets/images/PayrollFrame.svg";
import ShiftFrame from "../../../../assets/images/ShiftFrame.svg";
import BackgroundProfile from "../../../../assets/images/ProfileBackground.jpg";
import DummyPerson from "../../../../assets/images/DummyPerson.svg"
import Arrow from "../../../../assets/images/ArrowHistory.svg";
import CopyIcon from "../../../../assets/images/CopyIcon.svg";
import MyDiv from "./regularisationProfile.style"
import { useState } from "react";
import * as routesNames from '../../../../constants/routes';
import { useNavigate } from "react-router-dom";
import { CustomToast } from '../../../../components';
import { baseUrl, useFetch } from '../../../../hooks/useFetch';
import { useEffect } from "react";
import { ProfileDetail, props } from "./modal";
import { useAuth } from "../../../../hooks/useAuth";
import { showDate } from "../../../../utilities/helper";

const RegularisationProfile = ({ employeeId }: props) => {
  const { addToast } = CustomToast();
  const { fetchApi } = useFetch(addToast);
  const [employee, setEmployee] = useState<ProfileDetail | null>(null);
  const { loginObj } = useAuth();
  const [avatarUrl, setAvatarUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!employee?.id) return;

    const fetchAvatar = async () => {
      try {
        const res = await fetch(`${baseUrl}Hrlense_Employee/profilepic/${employee?.id}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${loginObj?.token || ""}`,
          },
        });

        if (!res.ok) throw new Error("Avatar not found");

        const blob = await res.blob();
        if (blob.size > 0) {
          setAvatarUrl(URL.createObjectURL(blob));
        } else {
          setAvatarUrl(null);
        }
      } catch (err) {
        console.error("Error fetching avatar", err);
        setAvatarUrl(null);
      }
    };

    fetchAvatar();
  }, [employee?.id]);

  const navigate = useNavigate();

  const LoadEmployee = async () => {
    if (!employeeId) {
      addToast({ message: "Employee ID is missing", status: "error" });
      return;
    };
    const response = await fetchApi('Hrlense_Employee/profileCard', "GET", null, `employeeId=${employeeId}`, "");
    if (response) {
      setEmployee(response);
    }
  }

  const handleClick = () => {
    navigate(routesNames.EMPLOYEEDETAIL, { state: { employeeId } });
  };

  useEffect(() => {
    LoadEmployee();
  }, [employeeId]);


  const infoItems = [
    { icon: DepartmentFrame, label: "Department", value: employee?.department },
    { icon: BranchFrame, label: "Branch", value: employee?.branch },
    { icon: EmailFrame, label: "Email", value: employee?.email },
    { icon: PhoneFrame, label: "Phone", value: employee?.phone },
    { icon: GenderFrame, label: "Gender", value: employee?.gender },
    { icon: CalenderFrame, label: "Age / DOB", value: `${employee?.age}, (${employee?.dob})`, },
    { icon: PayrollFrame, label: "Payroll Company", value: employee?.payrollCompany, },
    { icon: PayrollFrame, label: "Company", value: employee?.usCompany, },
    { icon: ShiftFrame, label: "Shift", value: employee?.shift },
  ];

  const copyToClipboard = (text: string, type: string) => {
    navigator.clipboard.writeText(text);
    addToast({ message: `${type} copied!`, status: 'success' });
  }
  return (
    <MyDiv>
      <Box className="profile-container">
        <Box className="scrollable-content">
          <Box className="main">
            <Box position="relative" h="140px" >
              <Image src={BackgroundProfile} alt="Cover" w="100%" h="100%" objectFit="cover" />
            </Box>
            <Flex align="center" gap={4} px={5} mt={-10}>
              <Avatar src={avatarUrl ? avatarUrl : DummyPerson} size="xl" name="" />
              <Box w="100%" mt={12} >
                <Flex justifyContent="space-between" alignItems="center" width="100%">
                  <Tooltip label={employee?.name} placement="top" hasArrow>
                    <Text className="font-poppins text_xl text_medium font_dark" maxWidth="12vw" isTruncated>
                      {employee?.name}
                    </Text>
                  </Tooltip>
                  <Text
                    className="font-poppins text_sm text_medium "
                    color={employee?.status === "Active" ? "green.500" : "red.500"}
                  >
                    {employee?.status}
                  </Text>

                </Flex>

                <Flex gap={3} mt={2} alignItems="center" flexWrap="wrap">
                  <Badge className="Badge font-poppins text_medium" fontSize="8px" color="rgba(0, 0, 0, 0.5)" >
                    {employee?.empCode}
                    <Image boxSize="11px" cursor="pointer"
                      src={CopyIcon}
                      alt="Copy"
                      ml={2}
                      onClick={(e) => {
                        e.stopPropagation();
                        copyToClipboard(employee?.empCode ?? "", "Employee ID");
                      }}
                    />
                  </Badge>
                  <Tooltip label={employee?.designation} placement="top" hasArrow>
                    <Badge className="designation font-poppins text_sm text_medium" color="rgba(0, 122, 255, 1)" maxWidth="8vw" isTruncated>
                      {employee?.designation}
                    </Badge>
                  </Tooltip>
                </Flex>
              </Box>
            </Flex>

            <Divider orientation='horizontal' mt={6} />

            <Box px={5} mt={6} pb={5}>

              <Text className="font-poppins text_sm text_medium" color="rgba(0, 0, 0, 1)" mb={3} >More Information</Text>

              <Box display="grid" rowGap={4}>
                {infoItems.map((item, idx) => (
                  <Flex key={idx} align="center" gap={3}>
                    <Image src={item.icon} boxSize="24px" alt={item.label} />
                    <Box>
                      <Text className="font-poppins text_medium" fontSize="9px" color="rgba(0, 0, 0, 0.5)">{item.label}</Text>
                      <Text className="font-poppins text_sm text_medium" color="rgba(0, 0, 0, 1)">
                        {item.label === 'Age / DOB' ? `${employee?.age}, (${showDate(employee?.dob)})` : item.value}
                      </Text>
                    </Box>
                  </Flex>
                ))}
                {/* <Box mt={2} className="history_btn">
                  <Flex justifyContent="space-between" alignItems="center" cursor="pointer" onClick={handleClick}>
                    <Text className="font-poppins font_dark text_medium text_sm">View Employee Profile</Text>
                    <Image src={Arrow} alt="History" />
                  </Flex>
                </Box> */}
              </Box>

            </Box>
          </Box>
        </Box>
      </Box>
      {/* <AlertCard isOpen={isOpen} onClose={onClose} onConfirm={handleConfirmStatusChange} /> */}
    </MyDiv>
  );
};

export default RegularisationProfile;
